import React from 'react';
import { ErrorSection } from '../../content-sections/ui/components/error/ErrorSection';
import { IllustratedErrorMessage } from '../../shared/components';
import ContentWrap from '../../../ui/components/Layout/ContentWrap';

export const ErrorBoundaries = () => (
	<>
		<ContentWrap>
			<h2 id="error-boundaries">Error boundaries</h2>
			<h3>Page errors</h3>
		</ContentWrap>

		<IllustratedErrorMessage />

		<ContentWrap>
			<br />
			<br />
			<h3>Section errors</h3>
		</ContentWrap>

		<ErrorSection contentType="test section" entryId="foo" />
	</>
);
